import { CHANGE_SIDEBAR_VISIBILITY } from '../actions/basics_action/sidebarActions';

const initialState = {
    collapse: true,
};

export const Sidebar = (state = initialState, action) => {
    switch (action.type) {
    case CHANGE_SIDEBAR_VISIBILITY:
        return { ...state, collapse: !state.collapse };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/App/redux/reducers/sidebar_reducers.js